import AddNewStationBtn from "../NewStation/NewStationForm/AddNewStationBtn/AddNewStationBtn";
import StationFilterPresenter from "./StationFilter/StationFilter";
import StationListPresenter from "./StationList/StationListPresenter";

export const StationList = {
    List : StationListPresenter,
    AddNew: AddNewStationBtn,
    Filter: StationFilterPresenter
}

export default StationList;